import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    insideResultsMixin
} from './vue/mixins/inside';

initMain([insideResultsMixin], {
    InsideAcResults: () => import('./vue/components/inside-ac-results/InsideAcResults.vue'),
    InsidePager: () => import('./vue/components/inside-pager/InsidePager.vue')
}, []);
header();